import { schema as objectiveProductRequirementsAssetFinance } from './ObjectiveProductRequirementsAssetFinance.schema';
import { labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    assetFinance: objectiveProductRequirementsAssetFinance(
      Joi,
      labeled(label, 'Asset finance - ')
    )
  });

export default {
  schema
};
